/** Regras de senha (GUI: mínimo 6 caracteres + confirmação igual). */
export const MIN_PASSWORD_LENGTH = 6;

/** Validação de nova senha + confirmação. Retorna mensagem de erro ou null. */
export function validateNewPassword(password: string, confirm: string): string | null {
  if (!password) return "Senha é obrigatória";
  if (password.length < MIN_PASSWORD_LENGTH) return `Mínimo de ${MIN_PASSWORD_LENGTH} caracteres`;
  if (password !== confirm) return "As senhas não conferem";
  return null;
}
